var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResources24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.133 3.556H.667v9.629a1.494 1.494 0 00.43 1.048 1.468 1.468 0 001.037.434h11v-1.482H2.133v-9.63z",
    fill: "#002147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.867 3.556H10.2l-1.21-1.63a1.475 1.475 0 00-1.173-.593h-2.75a1.46 1.46 0 00-1.038.434 1.49 1.49 0 00-.43 1.048v7.407c0 .393.155.77.43 1.048a1.46 1.46 0 001.038.434h8.8c.389 0 .762-.156 1.037-.434a1.49 1.49 0 00.43-1.048V5.037c0-.393-.155-.77-.43-1.047a1.46 1.46 0 00-1.037-.434zm-8.8 6.666V2.815h2.75l1.21 1.63a1.475 1.475 0 001.173.592h3.667v5.185h-8.8z",
    fill: "#002147"
  })));
}
export default SvgIconResources24;